/**
 * WYSIWYG Product Embed Listener
 * All event wiring for the product-embed feature lives here (per the
 * -listener.ts convention: no addEventListener calls outside this file for
 * this feature). Note: the toolbar button is a plain manually-created
 * <button> (see wysiwyg-product-embed-render.ts), not a Quill toolbar
 * format, so it's bound with a normal click listener rather than
 * toolbar.addHandler().
 */

import type { WysiwygProductEmbedHandler } from "./wysiwyg-product-embed-handler";

class WysiwygProductEmbedListener {
    public static bind(
        toolbarButton: HTMLButtonElement,
        searchInput: HTMLInputElement,
        handler: WysiwygProductEmbedHandler,
    ): void {
        toolbarButton.addEventListener("click", () => handler.handleToolbarClick());

        searchInput.addEventListener("search-menu:product-selected", (event: Event) =>
            handler.handleProductSelected(event),
        );
    }
}

export { WysiwygProductEmbedListener };
